import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Typography, Alert, FormControl, Select, MenuItem, Autocomplete } from "@mui/material";
import MjLabel from "../../../components/ui/MjLabel";
import MjErrorText from "../../../components/ui/MjErrorText";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useAuthContext } from "../../../hooks/useAuthContext";
import Api from "../../../api/Api";
import { Urls } from "../../../api/Urls";
import { useLocation, useParams } from "react-router-dom";
import UpdateAdminAccount from "./UpdateAdminAccount";
import SecuriteAdmin from "./SecuriteAdmin";
import HistoriqueLogins from "./HistoriquLogins";

function ContentSelector() {
  const params = useParams();
  // console.log("PARAMS = ", params);
  const location = useLocation();
  // console.log("LOCATION = ", location);
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const [succes, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [agencies, setAgencies] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [searchedAgency, setSearchedAgency] = useState("");
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [searchedRole, setSearchedRole] = useState("");

  const [admin, setAdmin] = useState({});

  const [selectedTab, setSelectedTab] = useState(1);

  const tabs = [
    {
      id: 1,
      name: "Détail",
      icon: "📋",
    },
    {
      id: 2,
      name: "Compte",
      icon: "🔒",
    },
    {
      id: 3,
      name: "Historique",
      icon: "📜",
    },
  ];

  const contentSelector = (contentId = 1) => {
    switch (contentId) {
      case 1:
        return <UpdateAdminAccount />;
      case 2:
        return <SecuriteAdmin idAdmin={admin.id} />;
      case 3:
        return <HistoriqueLogins idAdmin={admin.id} />;

      default:
        return <UpdateAdminAccount />;
    }
  };

  //get admin
  useEffect(() => {
    Api.get(Urls.GET_LISTE_ADMIN + `/${params.id}`, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        setAdmin(res?.data?.admin);
        console.log("ADMIN :", res.data.admin);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Box>
      {/* Header Section */}
      <Box className="header" sx={{ marginBottom: "1rem" }}>
        <Typography variant="h4" component="h1" fontWeight="600" mb>
          Gestion des comptes admin
        </Typography>
        <Typography variant="h5" component="h1" fontWeight="600">
          {admin.first_name + " " + admin.last_name + " #" + admin.id}
        </Typography>
      </Box>

      {/* tabs */}
      <Box display="flex" sx={{ maxWidth: "700px", backgroundColor: "#FAFAFB", borderRadius: "6px", padding: "2px", flexDirection: { md: "row", xs: "column" } }} gap="6px" margin="40px 0px">
        {tabs.map((tab, index) => (
          <Button disableRipple fullWidth key={index} variant={selectedTab === tab.id ? "mj_primary_choice_active_lg" : "mj_primary_choice_lg"} onClick={() => setSelectedTab(tab.id)}>
            <Typography fontSize="20px" mr>
              {tab.icon}
            </Typography>
            {tab.name}
          </Button>
        ))}
      </Box>

      {/* content */}
      {contentSelector(selectedTab)}
    </Box>
  );
}

export default ContentSelector;
